import {
  fetchGet,
  fetchPost,
  fetchPut,
  toQueryString,
} from "../../../service/api_client";
import { ApplyOptions } from "../models/types";

const base = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/request-desk`;

// Raise a request. Always sent as FormData (the create route runs multer); the
// structured payload rides in the "data" field, files under "attachment".
export const raiseRequestApi = async (payload: any, files: File[] = []) => {
  try {
    const form = new FormData();
    form.append("data", JSON.stringify(payload));
    files.forEach((f) => form.append("attachment", f));
    return await fetchPost(base, form);
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const listRequestsApi = async (params: Record<string, any>) => {
  try {
    return await fetchGet(base + toQueryString(params));
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const getRequestDetailApi = async (id: string) => {
  try {
    return await fetchGet(`${base}/${id}`);
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const entityLookupApi = async (type: string, ref: string) => {
  try {
    return await fetchGet(
      `${base}/entity-lookup` + toQueryString({ type, ref }),
    );
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const approveRequestApi = async (id: string) => {
  try {
    return await fetchPut(`${base}/${id}/approve`, {});
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const rejectRequestApi = async (
  id: string,
  rejection_reason: string,
) => {
  try {
    return await fetchPut(`${base}/${id}/reject`, { rejection_reason });
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const assignRequestApi = async (
  id: string,
  body: { assigned_to: string; assigned_to_name?: string; priority?: string },
) => {
  try {
    return await fetchPut(`${base}/${id}/assign`, body);
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const updateStatusApi = async (
  id: string,
  body: { status: string; resolution_note?: string },
) => {
  try {
    return await fetchPut(`${base}/${id}/status`, body);
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const addCommentApi = async (id: string, text: string) => {
  try {
    return await fetchPost(`${base}/${id}/comments`, { text });
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

// Assignment pick-list: active employees holding Request Desk execute permission.
// Sourced from the role system, so it needs no frontend role knowledge.
export const assignableDevsApi = async (search: string) => {
  try {
    return await fetchGet(
      `${base}/assignable-devs` + toQueryString({ search }),
    );
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

// ERP-176 Phase 2: pure preview (no writes) of the SR's change_requested
// applied against its linked PO/SO/ST.
export const applyPreviewApi = async (id: string, options: ApplyOptions) => {
  try {
    return await fetchPost(`${base}/${id}/apply-preview`, options);
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

// Re-runs the same preview fresh against live state and, if still ok, commits
// it and resolves the SR.
export const applyApi = async (id: string, options: ApplyOptions) => {
  try {
    return await fetchPost(`${base}/${id}/apply`, options);
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const getFaultDashboardApi = async (filters: Record<string, any>) => {
  try {
    return await fetchGet(`${base}/dashboard/faults` + toQueryString(filters));
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};
